/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { RecurringJobComponent } from "@src/app/modules/crm/recurring-job/recurring-job.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const RecurringJobPageNavRoute = new NavRoute('crm/recurringJobs', ()=>RecurringJobComponent, 'repeat').setViews( (user: User ) => {
    return [
        {
            id: 'mine',
            name: 'My OMCs Recurring Jobs',
            helpText: 'Recurring jobs for OMCs you manage; change the filter to view another manager\'s jobs',
            filterFields: {
                omc_managerId: user.id,
                templateId: 'All',
                frequencyId: '!=0',
                omcId: 'All',
            },
            sort: 'nextOccurence'
        },
        {
            id: 'myadmin',
            name: 'My Admin OMCs Recurring Jobs',
            helpText: 'Recurring jobs for OMCs where you are administrator; change the filter to view another administrator\'s jobs',
            filterFields: {
                omc_adminId: user.id,
                templateId: 'All',
                frequencyId: '!=0',
                omcId: 'All',
            },
            sort: 'nextOccurence'
        },
        {
            id: 'myfinance',
            name: 'My Finance OMCs Recurring Jobs',
            helpText: 'Recurring jobs for OMCs where you are finance manager; change the filter to view another finance manager\'s jobs',
            filterFields: {
                omc_financeId: user.id,
                templateId: 'All',
                frequencyId: '!=0',
                omcId: 'All',
            },
            sort: 'nextOccurence'
        },
        {
            id: 'all',
            name: 'All Recurring Jobs',
            helpText: 'All recurring jobs across all OMCs',
            sort: 'nextOccurence',
            filterFields: {
                templateId: 'All',
                frequencyId: '!=0',
                omcId: 'All',
            },
        }
    ]
}).setCharts( [
    { type: 'bar', picklist: 'omcId' } as ChartParms,
    { type: 'bar', picklist: 'templateId'} as ChartParms,
    { type: 'pie', picklist: 'frequencyId'} as ChartParms,
    { type: 'pie', picklist: 'lastRequest_srStatus'} as ChartParms
])
